import React, { useState, useEffect } from 'react'
import Footer from '../components/Footer'
import AdmissionInfo from '../components/AdmissionInfo'
import AdMoreInfo from '../components/AdMoreInfo'
import ApplyNow from '../components/ApplyNow'
import img25 from '../assets/image25.jpg'
import img24 from '../assets/image24.avif'
import img6 from '../assets/image6.jpg'
import '../styles/hero.css'

const Admission = () => {
  const images = [img25, img24, img6]
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setCurrent((c) => (c + 1) % images.length), 4200)
    return () => clearInterval(id)
  }, [images.length])

  return (
    <>
      <div className="page-hero admission-hero">
        {images.map((img, i) => (
          <div
            key={i}
            className={`bg-layer ${i === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <button className="hero-nav prev" onClick={() => setCurrent((current - 1 + images.length) % images.length)} aria-label="Previous image">‹</button>
        <button className="hero-nav next" onClick={() => setCurrent((current + 1) % images.length)} aria-label="Next image">›</button>
        <div className="page-hero-inner">
          <h2 className="title">Admission</h2>
        </div>
        <div className="hero-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`hero-dot ${i === current ? 'active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to image ${i + 1}`}
            />
          ))}
        </div>
      </div>
      <AdmissionInfo />
     {/*} <AdMoreInfo />*/}
      <ApplyNow />
      <Footer />
    </>
  )
}

export default Admission